import { useEffect, useRef } from 'react'
import { TimelineMax as Timeline } from 'gsap'
import { useSplashScreen } from '../slices/ui'

const SplashScreenManager = (props) => {

  const visible = useSplashScreen()
  const timeline = useRef()

  useEffect(()=>{
    timeline.current = new Timeline({ paused: true })
    timeline.current.to("#splashscreen > .splashscreen__text", {duration: .5, opacity: 0}, 1);
    timeline.current.to("#splashscreen > svg > path", {duration: 1.5, attr: {fill:"transparent"}}, 1);
    timeline.current.to("#splashscreen > svg > path:first-of-type", {duration: 1, attr: {"stroke-dashoffset":"986px"}}, 1.3);
    timeline.current.to("#splashscreen", {duration:.5, opacity:0})
    timeline.current.to("#splashscreen", {display: 'none'})
    timeline.current.to("#splashscreen", {attr: {"aria-hidden": "true"}})
  }, [])

  useEffect(()=>{
    if (!visible){
      timeline.current.play()
    } else {
      timeline.current.reverse()
    }
  },[visible])

  return null
}

export default SplashScreenManager
